import { Component, computed, inject, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeBusinessBranchComponent } from 'src/app/change-business-branch/change-business-branch.component';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { BranchWithBusiness, License } from 'src/model/business';
import { toWithFormattedAddress, WithFormattedAddress } from 'src/model/business/address.model';
import { BusinessStore } from 'src/model/business/business-store';
import { Company } from 'src/model/company.model';

@Component({
    selector: 'app-business-branch-company-list',
    templateUrl: './business-branch-company-list.component.html',
    styleUrl: './business-branch-company-list.component.scss',
    standalone: false
})
export class BusinessBranchCompanyListComponent {
  private activeModal = inject(NgbActiveModal);
  private sharedService = inject(SharedService);
  private store = inject(BusinessStore);

  activeLicenseByBranch = this.store.activeLicenseByBranch;

  @Input() companyList: Company[] = [];
  @Input() branch: BranchWithBusiness;

  activeLicense = computed<WithFormattedAddress<License>>(() => {
    const b = this.branch;
    const list = this.activeLicenseByBranch().get(b.Id);
    return list?.length > 0 ? toWithFormattedAddress(list[0]) : undefined;
  });

  reset() {
    this.activeModal.close();
  }

  changeBranch(company: Company) {
    const modalRef = this.sharedService.openModal(ChangeBusinessBranchComponent, 'regularModal');
    const i = modalRef.componentInstance as ChangeBusinessBranchComponent;
    i.currentBranch = this.branch;
    i.activeLicense = this.activeLicense();
    modalRef.componentInstance.company = company;
  }
}
